import React from "react";
import { clsxm } from "../../clsxm";

export interface PUnderlinedText {
  isError?: boolean;
  isSuccess?: boolean;
  underlinedText?: string;
}

export const UnderlinedText: React.FC<PUnderlinedText> = ({
  isError = false,
  isSuccess = false,
  underlinedText,
}) => {
  // Conditional rendering logic
  if (isError) {
    return (
      <p
        className={clsxm(
          "text-text-status-red text-[12px] Body-Regular flex items-center mt-2",
          isError && "text-text-status-red",
          isSuccess && "text-primary-3"
        )}
      >
        <span className="material-symbols-outlined mr-1 text-[24px]">warning</span> {underlinedText}
      </p>
    );
  }

  // Return null or an empty element if there's no content to render
  return null;
};
